function selectAll(data, bool) {
    const arr = [];

    if (!bool) {
        data.forEach((d) => {
            arr.push(d.id);
        });
    }

    return arr;
}

export default selectAll;
